import React, { useState, useEffect } from "react";
import FullCalendar, { CalendarApi } from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import { Modal, DatePicker, Icon, Select } from "antd";
import deleteIcon from "../../assets/SVGs/delete.svg";
import { gapi } from "gapi-script";
import {
  initClient,
  checkLoginStatusAndInitialize,
  listEvents,
  createEvent,
  deleteEvent,
} from "./google-calendar-service";
import "./dashboard-calendar.css";
import "./monthly-static-calendar.css";
import MonthlyStaticCalender from "./MonthlyStaticCalendaer";
import { useTheme } from "../../utils/ThemeContext";
import DEATH_API from "../../apis/death.api";
import swal from "sweetalert";
import DASHBOARD_API from "../../apis/dashboard.api";
import NewLoader from "../styled-components/loader/NewLoader";
import moment from "moment";
import SpinLoader from "../styled-components/loader/SpinLoader";
import { ChartColors } from "../ChartColors";
const { Option } = Select;

const colors = ["#0062ff93", "#00ff4493", "#00b4ab94", "#ff150096"];
const calendarColors = [
  { id: "1", background: "#A4BDFC", foreground: "#1D1D1D" },
  { id: "2", background: "#7AE7BF", foreground: "#1D1D1D" },
  { id: "3", background: "#DBADFF", foreground: "#1D1D1D" },
  { id: "4", background: "#FF887C", foreground: "#1D1D1D" },
  { id: "5", background: "#FBD75B", foreground: "#1D1D1D" },
  { id: "6", background: "#FFB878", foreground: "#1D1D1D" },
  { id: "7", background: "#46D6DB", foreground: "#1D1D1D" },
  { id: "8", background: "#E1E1E1", foreground: "#1D1D1D" },
  { id: "9", background: "#5484ED", foreground: "#1D1D1D" },
  { id: "10", background: "#51B749", foreground: "#1D1D1D" },
  { id: "11", background: "#DC2127", foreground: "#1D1D1D" },
];
const DashboardCalendar = () => {
  const { theme } = useTheme();
  const assignColor = (index) => colors[index % colors.length];

  const [events, setEvents] = useState([]);
  const [allEvents, setAllEvents] = useState([]);
  const [allCalendarList, setAllCalendarList] = useState([]);

  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isReady, setReady] = useState(false);

  const userTimeZone = localStorage.getItem("userTimeZone");
  const googleLog = localStorage.getItem("googleAccessToken");
  const googleRefreshToken = localStorage.getItem("googleRefreshToken");
  const [modalVisible, setModalVisible] = useState(false);
  const [addEventModal, setAddEventModal] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [formDataEvent, setFormDataEvent] = useState(null);

  // const getAuthTokenForGoogle = async () => {
  //   try {
  //     const response = await DEATH_API.googleAuthLogin();

  //     console.log("responsetokengoogle", response);
  //   } catch (error) {
  //     console.log("error while logging in", error);
  //   }
  // };

  useEffect(() => {
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localStorage.setItem("userTimeZone", timeZone);
  }, []);
  const handleCancelAdd = () => {
    setAddEventModal(false);
    setFormDataEvent(null);
    setSelectedEvent(null);
  };
  const handleChange = (name, value) => {
    if(name==="start"){
      const newEndDate = moment(value).add(1, "hour").format("MM/DD/YYYY hh:mm A");
      console.log("newEndDate",newEndDate)
      setFormDataEvent({
        ...formDataEvent,
        [name]: value,
        ["end"]: newEndDate,
      });
    }else{
      setFormDataEvent({
        ...formDataEvent,
        [name]: value,
      });
    }
  };
  const handleSaveAdd = async () => {
    setAddEventModal(false);
    try {
      setLoading(true);
      const payload = {
        summary: formDataEvent && formDataEvent.summary,
        description: formDataEvent && formDataEvent.description,
        start: {
          dateTime:
            formDataEvent &&
            moment(formDataEvent.start).format("YYYY-MM-DDTHH:mm:ssZ"),
            timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        },
        end: {
          dateTime:
            formDataEvent &&
            moment(formDataEvent.end).format("YYYY-MM-DDTHH:mm:ssZ"),
            timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        },
        // colorId: formDataEvent && formDataEvent.colorId,
        calendarId: formDataEvent && formDataEvent.calendarId,
      };
   
      let res = await DASHBOARD_API.createEvent(payload);
      if (res) {
        console.log("Google event created successfully==>", res);
        const currentDate = new Date();
        currentDate.setMonth(currentDate.getMonth() - 3); // Subtract 3 months
        const threeMonthsBack = currentDate.toISOString();
        await getEventList(threeMonthsBack);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("error while trying to create google task==>", error);
    }
  };
  const handleDateSelect = async (selectInfo) => {
    // const title = prompt("Enter a title for your event:");
    const randomColor = colors[Math.floor(Math.random() * colors.length)];
    const timeZone = userTimeZone || "UTC";
    console.log("selectInfo", selectInfo);
    setAddEventModal(true);
    // const task = {
    //   summary: title,
    //   start: {
    //     dateTime: selectInfo.startStr,
    //     timeZone: timeZone,
    //   },
    //   end: {
    //     dateTime: selectInfo.endStr,
    //     timeZone: timeZone,
    //   },
    //   color: randomColor,
    // };
    const payload = {
      summary: "",
      description: "",
      start: moment(selectInfo.startStr).local().format("YYYY-MM-DDTHH:mm:ssZ"),
      end: moment(selectInfo.endStr).local().format("YYYY-MM-DDTHH:mm:ssZ"),
    };
    setFormDataEvent(payload);
    // setLoading(true);
    // try {
    //   let res = await DASHBOARD_API.createEvent(payload);

    //   if (res) {
    //     console.log("Google event created successfully==>", res);
    //     const currentDate = new Date();
    //     currentDate.setMonth(currentDate.getMonth() - 3); // Subtract 3 months
    //     const threeMonthsBack = currentDate.toISOString();
    //     await getEventList(threeMonthsBack);
    //   }
    // } catch (error) {
    //   setLoading(false);
    //   console.log("error while trying to create google task==>", error);
    // }
  };

  const handleEventClick = async (clickInfo) => {
    console.log("clickInfo", clickInfo,clickInfo.event.eventAccess,clickInfo.event.extendedProps.eventAccess);
    setSelectedEvent({
      title: clickInfo.event && clickInfo.event.title,
      start:
        clickInfo.event &&
        moment(clickInfo.event.start).format("YYYY-MM-DD HH:mm:ss"),
      end:
        clickInfo.event &&
        moment(clickInfo.event.end).format("YYYY-MM-DD HH:mm:ss"),
      id: clickInfo.event && clickInfo.event.id,
      location:
        clickInfo.event.extendedProps &&
        clickInfo.event.extendedProps.location &&
        clickInfo.event.extendedProps.location,
      description:
        clickInfo.event.extendedProps &&
        clickInfo.event.extendedProps.description &&
        clickInfo.event.extendedProps.description,
      hangoutLink:
        clickInfo.event.extendedProps &&
        clickInfo.event.extendedProps.hangoutLink &&
        clickInfo.event.extendedProps.hangoutLink,

      color:
        clickInfo.event &&
        clickInfo.event.backgroundColor &&
        clickInfo.event.backgroundColor,
      eventAccess:
        clickInfo.event.extendedProps &&
        clickInfo.event.extendedProps.eventAccess &&
        clickInfo.event.extendedProps.eventAccess,
      creator: clickInfo.event.extendedProps &&
        clickInfo.event.extendedProps.creator &&
        clickInfo.event.extendedProps.creator,
      createdBy:
        clickInfo.event.extendedProps &&
        clickInfo.event.extendedProps.createdBy &&
        clickInfo.event.extendedProps.createdBy,
    });
    setModalVisible(true); // Show the modal
    // if (
    //   window.confirm(
    //     `Are you sure you want to delete '${clickInfo.event.title}'?`
    //   )
    // ) {
    //   setEvents((prevEvents) =>
    //     prevEvents.filter((event) => event.id !== clickInfo.event.id)
    //   );
    // }
  };
  const handleModalClose = () => {
    setModalVisible(false);
    setSelectedEvent(null);

  };

  const handleGoogleLogin = async () => {
    try {
      setReady(true);
      const response = await DEATH_API.googleAuthLogin();
      if (response) {
        setReady(false);
        window.open(response.googleAuthUrl, "_self");
      }
    } catch (error) {
      setReady(false);
      console.log("error while logging in", error);
    }
  };
  function convertToLocalISO(dateTime) {
    const localDate = new Date(dateTime); // Automatically adjusts to local timezone
    const offset = -localDate.getTimezoneOffset(); // Get offset in minutes
    const sign = offset >= 0 ? "+" : "-";
    const hours = String(Math.floor(Math.abs(offset) / 60)).padStart(2, "0");
    const minutes = String(Math.abs(offset) % 60).padStart(2, "0");

    // Format the date into "YYYY-MM-DDTHH:mm:ss±hh:mm"
    console.log("dateTime here",localDate.toISOString().replace("Z", `${sign}${hours}:${minutes}`))
    return localDate.toISOString().replace("Z", `${sign}${hours}:${minutes}`);
  }

  const getEventList = async (date) => {
    if (googleLog && googleRefreshToken) {
      try {
        setLoading(true);
        const randomColor = colors[Math.floor(Math.random() * colors.length)];
        const response = await DASHBOARD_API.fetchEvents(date);
        console.log("events listing==>", response);

        if (response && response.data && response.data.events) {
          setAllEvents(response.data.events);
          let sortedArray = response.data.events.map((item, index) => {
            const matchingCalendar =
              response.data.list &&
              response.data.list.find(
                (calendar) => calendar.id === item.organizer.email
              );
            const eventColor = matchingCalendar
              ? matchingCalendar.backgroundColor
              : "#2a3da3";
            const eventAccess = matchingCalendar
              && matchingCalendar.accessRole;	
            let matchingColor = null;
            if (item && item.colorId && calendarColors) {
              matchingColor = calendarColors.find(
                (calendar) => calendar.id === item.colorId
              );
            }
            // Get the background color if a match is found, otherwise use a default color
            return {
              title: item.summary ? item.summary : "No title",
              start: item.start.dateTime
                ? item.start.dateTime
                : item.start.date,
              end: item.end.dateTime
                ? item.end.dateTime
                : item.end.date,
              id: item.id,
              backgroundColor: eventColor,
              borderColor: eventColor,
              location: item.location ? item.location : "No Location",
              description: item.description ? item.description : null,
              hangoutLink: item.hangoutLink ? item.hangoutLink : null,
              eventAccess: eventAccess ? eventAccess : null,
              creator:
                item.creator && item.creator.email ? item.creator.email : "N/A",
              createdBy:
                item.organizer && item.organizer.email ? item.organizer.email : "N/A",
            };
          });
          console.log("sortedArray==>", sortedArray);

          setEvents(sortedArray);
        }
        if (response && response.data && response.data.list) {
          setAllCalendarList(response.data.list);
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
        console.log("error while getting task list==>", error);
      }
    }
  };
  useEffect(() => {
    const currentDate = new Date();
    currentDate.setMonth(currentDate.getMonth() - 3); // Subtract 3 months
    const threeMonthsBack = currentDate.toISOString();
    getEventList(threeMonthsBack);
  }, []);
  const deleteGoogleEvent = async () => {
    setModalVisible(false);
    swal({
      title: "Are you sure?",
      text: "Are you sure you want to delete this ?",
      dangerMode: true,
      buttons: ["No, cancel it!", "Yes, delete it!"],
      icon: "warning",
      type: "warning",
      closeOnConfirm: false,
      closeOnCancel: false,
    }).then(async function (isConfirm) {
      // Redirect the user
      if (isConfirm) {
        try {
          setLoading(true);
          const calendarId = selectedEvent && selectedEvent.createdBy;
          const eventId = selectedEvent && selectedEvent.id;
          let res = await DASHBOARD_API.deleteCalendarEvent(
            calendarId,
            eventId
          );
          if (res && res.statusCode === 200) {
            swal("Deleted!", "Your Event has been deleted.", "success");
            await getEventList();
          }
          setLoading(false);
        } catch (error) {
          setLoading(false);
          console.log("error while deleting Event", error);
        }
      }
    });
    setSelectedEvent(null);
  };
  const updateGoogleEvent = () => {
    setModalVisible(false);
    let matchingColor = null;
    if (selectedEvent && selectedEvent.color && calendarColors) {
      matchingColor = calendarColors.find(
        (calendar) => calendar.background === selectedEvent.color
      );
    }
    let eventToUpdate = {
      summary: selectedEvent && selectedEvent.title,
      start: selectedEvent && moment(selectedEvent.start).local(),
      end: selectedEvent && moment(selectedEvent.end).local(),
      id: selectedEvent && selectedEvent.id,
      description: selectedEvent && selectedEvent.description ? selectedEvent.description : "",
      calendarId: selectedEvent && selectedEvent.createdBy,
      destinationCalendarId: selectedEvent && selectedEvent.createdBy,
      eventAccess: selectedEvent && selectedEvent.eventAccess,
      // colorId: matchingColor && matchingColor.id,
    };
    setFormDataEvent(eventToUpdate);
    setAddEventModal(true);
    // setSelectedEvent(null);
  };
  const handleUpdateEvent = async()=>{
    setAddEventModal(false);
    try {
      let payload = { 
        ...formDataEvent,
        eventId: formDataEvent && formDataEvent.id,
        start:{
          dateTime:formDataEvent && moment(formDataEvent.start).format("YYYY-MM-DDTHH:mm:ssZ"),
          // timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
          date: null,
        },
        end:{
          dateTime:formDataEvent && moment(formDataEvent.end).format("YYYY-MM-DDTHH:mm:ssZ"),
          // timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
          date: null,
        }
       };
       if(formDataEvent && formDataEvent.destinationCalendarId){
         payload.targetCalendarId=formDataEvent.destinationCalendarId;
       }
       setLoading(true);
      const res = await DASHBOARD_API.updateCalendarEvent(formDataEvent.calendarId,formDataEvent.id, payload);
      if(res && res.statusCode===200){
        swal("Success", res.message,"success");
        await getEventList();
      }
      setLoading(false);
    } catch (error) {
      console.error("Failed to update event status:", error);
      setLoading(false);
    }
    setSelectedEvent(null);
    setFormDataEvent(null);
  }
  const renderEventContent = (eventInfo) => {
    // console.log("renderEventContent", eventInfo.event);
    return (
      <div className="event-render"
        style={{
          backgroundColor:
            eventInfo.event &&
            eventInfo.event.backgroundColor &&
            eventInfo.event.backgroundColor,
            lineHeight: eventInfo.view.type === "timeGridDay" ? "2px" :"12px",
        }}
      >
        <span style={{ fontWeight: "bold",
          // lineHeight: eventInfo.view.type === "timeGridDay" && "4px"
         }}>{eventInfo.event.title}</span>
        {!(
          (eventInfo.view.type === "timeGridWeek" && eventInfo.timeText === "") ||
            eventInfo.view.type === "timeGridDay" 
        ) && (
          <span>
            {eventInfo.event &&
              eventInfo.event.start &&
              moment(eventInfo.event.start).format("hh:mm a")}{" "}
            -{" "}
            {eventInfo.event &&
              eventInfo.event.end &&
              moment(eventInfo.event.end).format("hh:mm a")}
          </span>
        )}
        {!(
          (eventInfo.view.type === "timeGridWeek" && eventInfo.timeText === "") ||
            eventInfo.view.type === "timeGridDay" 
        ) && <span>{eventInfo.event.extendedProps.location}</span>}
      </div>
    );
  };

  const showFilterEvents = (selectedCalendars) => {
    const filteredEvents =
      allEvents &&
      allEvents.filter((event) =>
        selectedCalendars.includes(event.organizer.email)
      );
    let sortedArray =
      filteredEvents &&
      filteredEvents.map((item, index) => {
        const matchingCalendar =
          allCalendarList &&
          allCalendarList.find(
            (calendar) => calendar.id === item.organizer.email
          );

        // Get the background color if a match is found, otherwise use a default color
        const eventColor = matchingCalendar
          ? matchingCalendar.backgroundColor
          : "#2a3da3";
        const eventAccess = matchingCalendar
          && matchingCalendar.accessRole;	
        let matchingColor = null;
        if (item && item.colorId && calendarColors) {
          matchingColor = calendarColors.find(
            (calendar) => calendar.id === item.colorId
          );
        }
        return {
          title: item.summary ? item.summary : "No title",
          start: item.start.dateTime
            ? item.start.dateTime
            : item.start.date,
          end: item.end.dateTime
            ? item.end.dateTime
            : item.end.date,
          id: item.id,
          backgroundColor: eventColor,
          borderColor: eventColor,
          location: item.location ? item.location : "No Location",
          description: item.description ? item.description : null,
          hangoutLink: item.hangoutLink ? item.hangoutLink : null,
          eventAccess: eventAccess ? eventAccess : null,
          creator:
              item.creator && item.creator.email ? item.creator.email : "N/A",
          createdBy:
            item.organizer && item.organizer.email ? item.organizer.email : "N/A",
        };
      });
    setEvents(sortedArray);
  };

  return (
    <div style={{ position: "relative" }}>
      <div
        style={{
          display: "flex",
          width: "100%",
          alignItems: "center",
          justifyContent: "flex-end",
          gap: "12px",
        }}
      >
      {googleLog &&
        <button
        className="google-login-button"
          onClick={() => {
            getEventList();
          }}
        >
        Refresh
        </button>
        }
        { localStorage.getItem('role') &&  JSON.parse(localStorage.getItem('role')) !== "Financial Advisor Client" && (<button
          style={{ marginRight: "20px" }}
          className="google-login-button"
          onClick={() => {
            handleGoogleLogin();
          }}
        >
          {isReady ? (
            <SpinLoader isLoading={isReady} />
          ) : !googleLog ? (
            "Login with Google"
          ) : (
            "Change Account"
          )}
        </button>)}
      </div>

      <div
        style={{
          backgroundColor: theme === "dark" ? "#232323" : "white",
        }}
        className="dashboard-calendars-main-container"
      >
        <>
          <div className="monthly-static-calendar-container-main">
            <MonthlyStaticCalender
              events={allEvents && allEvents}
              list={allCalendarList && allCalendarList}
              filterEvents={showFilterEvents}
            />
          </div>
          <div
            style={{
              backgroundColor: theme === "dark" ? "#232323" : "white",
            }}
            className={`dashboard-calendar-right ${theme === "dark" ? "dark-theme" : "light-theme"}`}
          >
            <FullCalendar
              plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
              headerToolbar={{
                left: "prev,today,next",
                right: "dayGridMonth,timeGridWeek,timeGridDay,yearView",
                center: "title",
              }}
              eventContent={renderEventContent}
              initialView="timeGridWeek"
              // slotMinTime="01:00:00"
              // slotMaxTime="23:00:00"
              editable={true}
              selectable={true}
              events={events}
              select={handleDateSelect}
              eventClick={handleEventClick}
              themeSystem="standard"
            />
          </div>
        </>
      </div>
      {/* Event Details Modal */}
      <Modal
        visible={modalVisible}
        onOk={handleModalClose}
        onCancel={handleModalClose}
        footer={null}
        closable={false}
        centered
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            gap: "1rem",
          }}
        >
          <h3 className="modaltitle">Event Details</h3>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              gap: "1rem",
            }}
          >
            <Icon
              type="delete"
              style={{ cursor: "pointer", fontSize: "20px", color: "#2a3da3" }}
              onClick={() => {
                if (selectedEvent) {
                  deleteGoogleEvent(selectedEvent);
                }
              }}
            />
            <Icon
              type="edit"
              style={{ cursor: "pointer", fontSize: "20px", color: "#2a3da3" }}
              onClick={() => {
                if (selectedEvent) {
                  updateGoogleEvent(selectedEvent);
                }
              }}
            />
          </div>
        </div>
        {selectedEvent ? (
          <div style={{ color: "#2a3da3" }}>
            <p>
              <strong>Title:</strong>{" "}
              {selectedEvent.title ? selectedEvent.title : "N/A"}
            </p>
            <p>
              <strong>Start:</strong>{" "}
              {selectedEvent.start
                ? moment(selectedEvent.start).format("MM-DD-YYYY hh:mm a")
                : "N/A"}
            </p>
            <p>
              <strong>End:</strong>{" "}
              {selectedEvent.end
                ? moment(selectedEvent.end).format("MM-DD-YYYY hh:mm a")
                : "N/A"}
            </p>
            <p>
              <strong>Created By:</strong>{" "}
              {selectedEvent.creator ? selectedEvent.creator : "N/A"}
            </p>
            <p>
              <strong>Location:</strong>{" "}
              {selectedEvent.location ? selectedEvent.location : "N/A"}
            </p>
            <p>
              <strong>Description:</strong>{" "}
              {selectedEvent.description ? selectedEvent.description : "N/A"}
            </p>
            {/* <p>
              <strong>Link:</strong>{" "}
              {selectedEvent.hangoutLink ? (
                <a href={selectedEvent.hangoutLink} target="_blank">
                  {selectedEvent.hangoutLink
                    ? selectedEvent.hangoutLink
                    : "N/A"}
                </a>
              ) : (
                "N/A"
              )}
            </p> */}
          </div>
        ) : (
          <h3 className="inputTitle">No Details Found</h3>
        )}
        <div className="buttonsMain" style={{ justifyContent: "center" }}>
          <button
            className="savebutton"
            onClick={() => {
              handleModalClose();
            }}
          >
            Close
          </button>
        </div>
      </Modal>
      {/* Event Add Modal */}
      <Modal
        visible={addEventModal}
        footer={null}
        onOk={handleCancelAdd}
        onCancel={handleCancelAdd}
        closable={false}
        centered
      >
        <div style={{ display: "flex", gap: "1rem", alignItems: "center" }}>
          <h3 className="modaltitle">{selectedEvent ? "Update " : "Add "}Event</h3>
        </div>
        <div
          style={{
            maxHeight: "25rem",
            overflow: "scroll",
            padding: "1rem",
          }}
        >
          <div style={{ marginBottom: "8px" }}>
            <h3 className="inputTitle">Start Date/Time</h3>
            <DatePicker
              style={{
                width: "100%",
                border: "1px solid #d1d5db",
                borderRadius: "5px",
              }}
              size="large"
              showTime={{ format: "hh:mm A" }}
              format={"MM/DD/YYYY hh:mm A"}
              placeholder="Start Date/Time"
              name="start"
              value={
                formDataEvent &&
                formDataEvent.start &&
                moment(formDataEvent.start).local()
              }
              id="newDate"
              onChange={(date, dateString) => {
                handleChange("start", dateString);
              }}
            />
          </div>
          <div style={{ marginBottom: "8px" }}>
            <h3 className="inputTitle">End Date/Time</h3>
            <DatePicker
              style={{
                width: "100%",
                border: "1px solid #d1d5db",
                borderRadius: "5px",
              }}
              size="large"
              showTime={{ format: "hh:mm A" }}
              format={"MM/DD/YYYY  hh:mm A"}
              placeholder="End Date/Time"
              name="end"
              value={
                formDataEvent &&
                formDataEvent.end &&
                moment(formDataEvent.end).local()
              }
              id="newDate"
              onChange={(date, dateString) => {
                handleChange("end", dateString);
              }}
            />
          </div>
          <div style={{ marginBottom: "8px" }}>
            <h3 className="inputTitle">Event Title</h3>
            <input
              className="roleInput"
              placeholder="Title"
              name="summary"
              value={formDataEvent && formDataEvent.summary}
              id="asset"
              onChange={(e) => {
                e.preventDefault();
                handleChange(e.target.name, e.target.value);
              }}
            />
          </div>
          <div style={{ marginBottom: "8px" }}>
            <h3 className="inputTitle">Event Description</h3>
            <input
              className="roleInput"
              placeholder="Description"
              name="description"
              value={formDataEvent && formDataEvent.description}
              id="asset"
              onChange={(e) => {
                e.preventDefault();
                handleChange(e.target.name, e.target.value);
              }}
            />
          </div>
          {(selectedEvent && selectedEvent) ?
          <div style={{ marginBottom: "8px" }}>
            <h3 className="inputTitle">Calendar</h3>
            <Select
              showSearch
              placeholder="Select Calendar"
              disabled={formDataEvent && formDataEvent.eventAccess==="reader" ? true : false}
              value={formDataEvent && formDataEvent.destinationCalendarId}
              onChange={(value) => {
                console.log("value", value);
                handleChange("destinationCalendarId", value);
              }}
            >
                {allCalendarList &&
                  allCalendarList
                    .filter(item => item.accessRole !== "reader")
                    .map((item, index) => (
                      <Option key={index} value={item.id}>
                        {item.summary}
                      </Option>
                    ))}
            </Select>
          </div>
          :
          <div style={{ marginBottom: "8px" }}>
          <h3 className="inputTitle">Calendar</h3>
          <Select
            showSearch
            placeholder="Select Calendar"
            disabled={formDataEvent && formDataEvent.eventAccess==="reader" ? true : false}
            value={formDataEvent && formDataEvent.calendarId}
            onChange={(value) => {
              console.log("value", value);
              handleChange("calendarId", value);
            }}
          >
          {allCalendarList &&
            allCalendarList
              .filter(item => item.accessRole !== "reader") 
              .map((item, index) => (
                <Option key={index} value={item.id}>
                  {item.summary}
                </Option>
              ))}
          </Select>
        </div> }
         {/* <div style={{ marginBottom: "8px" }}>
            <h3 className="inputTitle">Color</h3>
            <Select
              showSearch
              placeholder="Select Color"
              value={formDataEvent && formDataEvent.colorId}
              onChange={(value) => {
                console.log("value", value);
                handleChange("colorId", value);
              }}
              optionLabelProp="label"
            >
              {calendarColors &&
                calendarColors.map((item, index) => (
                  <Option
                    key={index}
                    value={item.id}
                    label={
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                        }}
                      >
                        <div
                          style={{
                            backgroundColor: item.background,
                            width: "24px",
                            height: "24px",
                            borderRadius: "50%",
                            marginTop: "2px",
                          }}
                        />
                      </div>
                    }
                  >
                    <div
                      aria-label={item.background}
                      style={{
                        background: `${item.background}`,
                        width: "24px",
                        height: "24px",
                        borderRadius: "50%",
                      }}
                    ></div>
                  </Option>
                ))}
            </Select>
          </div> */}
        </div>
        <div className="buttonsMain">
          <button
            className="cancelbutton"
            onClick={() => {
              handleCancelAdd();
            }}
          >
            Cancel
          </button>
          <button
            className="savebutton"
            // disabled={!data || !data.asset}
            onClick={() => {
              if(selectedEvent && selectedEvent){
                handleUpdateEvent();
              }else{
                handleSaveAdd();
              }
            }}
          >
            Save
          </button>
        </div>
      </Modal>

      <NewLoader isLoading={loading} />
    </div>
  );
};

export default DashboardCalendar;
